<!-- eslint-disable vue/multi-word-component-names -->
<script>
  import BasicInformation from '@/components/Doctor/missionIonDetail/misssionInformation/basicInformation.vue';
  import PatientsInformation from '@/components/Doctor/missionIonDetail/misssionInformation/patientsInformation.vue';
  // ------------------------------
  import PatientDoctorDetailMixin from '@/Mixins/Doctor/PatientDoctorDetailMixin';
  import MissionPhonesMixin from '@/Mixins/Mission/MissionPhonesMixin';
  export default {
    components: {
      BasicInformation,
      PatientsInformation,
    },
    mixins: [PatientDoctorDetailMixin, MissionPhonesMixin],
    props: {
      missionPhoneId: {
        type: Number,
        default: 0,
      },
      basicInformation: {
        type: Object,
        default: () => {},
      },
      patients: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {};
    },
    mounted() {},
    methods: {},
  };
</script>
<template>
  <v-row>
    <v-col cols="12" class="bg-white">
      <basic-information
        :mission-phone-id="missionPhoneId"
        :creation-date="basicInformation?.creationDate"
        :phoneCode="basicInformation?.phoneCode"
        :phone-number="basicInformation?.phoneNumber"
        :chief-complaint-text="basicInformation?.chiefComplaintText"
        :chief-complaint-note="basicInformation?.chiefComplaintNote"
        :address="basicInformation?.address"
        :hospital="basicInformation?.hospital"
        :diagnosisTitle="basicInformation?.diagnosisTitle"
        @sendMissionToHospital="(body, onSuccess) => $emit('onChangeHospital', body, onSuccess)"
      />

      <patients-information
        :patients="patients"
        @changePatient="(id) => $emit('onChangePatient', id)"
      />
    </v-col>
  </v-row>
</template>
